<template>
    <v-dialog v-model="show" width="650px" @click:outside="close">
        <!-- <template v-slot:activator="{ on }"> </template> -->
        <div class="modal">
            <v-row>
                <div class="icon-modal table-cell">
                    <v-layout class="align-center">
                        <v-flex>
                            <img style="position: relative;top: -6px;left: 8px;" :src="require('@/assets/img/hand.svg')" alt=""/>
                        </v-flex>
                    </v-layout>
                </div>
                <v-col class="table-cell modal-content">
                    <div class="d-flex justify-space-between">
                        <h6 class="modal-title mb-5">Congratulations!</h6>
                        <v-btn class="modal-close custom-close" rounded depressed @click="close">
                            <img class="close-icon"
                                 :src="require('@/assets/img/close.png')" alt=""/>
                        </v-btn>
                    </div>
                    <p class="mb-0" style="position: relative;top: -3px;">
                        <b>Your account is now active</b>
                    </p>
                    <v-row class="store-buttons" style="position: relative;left: -1px;">
                        <div class="table-cell">
                            <a :href="this.$store.getters['Authenticate/getAppleStoreUrl']" target="_blank">
                                <img :src="require('@/assets/img/apple_store.svg')" alt=""/>
                            </a>
                        </div>
                        <div class="table-cell">
                            <a :href="this.$store.getters['Authenticate/getGooglePlayUrl']" target="_blank">
                                <img :src="require('@/assets/img/google_play.svg')" alt=""/>
                            </a>
                        </div>
                    </v-row>
                    <v-spacer></v-spacer>
                </v-col>
            </v-row>
        </div>
    </v-dialog>
</template>
<style scoped>
    .custom-close:before {
        border-radius: inherit;
        background-color: transparent;
    }
</style>
<script>
    export default {
        props: ['show', 'hide'],
        components: {},
        methods: {
            close: function () {
                this.hide();
            }
        },
    };
</script>